import ConfirmationSMS from './ConfirmationSMS'

export default {
  install(Vue) {
    Vue.component('confirmation-sms', ConfirmationSMS)
  },
}
